import styled, { css } from 'styled-components';
import ReactSlider from 'react-slider';

export const Container = styled.div`
  width: -webkit-fill-available;
  width: -moz-available;
  padding: 20px 0;
`;

export const SliderComponent = styled(ReactSlider)`
  width: 100%;
  height: 3px;
`;

export const StyledThumb = styled.div`
  height: 20px;
  color: ${props => props.theme.fontColor};
  margin-top: -8px;
  line-height: 20px;
  width: 20px;
  text-align: center;

  border-radius: 50%;
  cursor: grab;
  ${({ color }) =>
    color === 'primary'
      ? css`
          box-shadow: 0 0 10px 0 ${props => props.theme.button.primary.out};
          background-color: ${props => props.theme.button.primary.out};
          /* color: ${props => props.theme.button.primary.out}; */
        `
      : css`
          box-shadow: 0 0 10px 0 ${props => props.theme.button.secondary.out};
          background-color: ${props => props.theme.button.secondary.out};
          /* color: ${props => props.theme.button.secondary.out}; */
        `}
`;

export const StyledTrack = styled.div`
  top: 0;
  bottom: 0;
  background: ${props =>
    !props.single
      ? props.index === 2
        ? '#ddd'
        : props.index === 1
        ? props.color === 'primary'
          ? props.theme.button.primary.out
          : props.theme.button.secondary.out
        : '#ddd'
      : props.index === 1
      ? '#ddd'
      : props.color === 'primary'
      ? props.theme.button.primary.out
      : props.theme.button.secondary.out};

  border-radius: 999px;
`;
